"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCumulativeProductionDailyV2Loading = exports.getCumulativeProductionDailyV2Error = exports.getCumulativeProductionDailyV2 = exports.fetchingCumulativeProductionDailyV2 = exports.fetchCumulativeProductionDailyV2Success = exports.fetchCumulativeProductionDailyV2IfNeeded = exports.fetchCumulativeProductionDailyV2Failure = exports.fetchCumulativeProductionDailyV2 = exports["default"] = exports.cumulativeProductionDailyV2InitialState = exports.appendCumulativeProductionDailyV2Page = exports.FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_SUCCESS = exports.FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_FAILURE = exports.FETCHING_CUMULATIVE_PRODUCTION_V2_DAILY = exports.APPEND_CUMULATIVE_PRODUCTION_V2_DAILY = void 0;

var _luxon = require("luxon");

var _immutable = require("immutable");

var _reselect = require("reselect");

var _CumulativeProduction = require("../api/CumulativeProduction");

var _timeseriesHelpers = require("./timeseriesHelpers");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_SUCCESS = 'performance/FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_SUCCESS';
exports.FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_SUCCESS = FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_SUCCESS;
var APPEND_CUMULATIVE_PRODUCTION_V2_DAILY = 'performance/APPEND_CUMULATIVE_PRODUCTION_V2_DAILY';
exports.APPEND_CUMULATIVE_PRODUCTION_V2_DAILY = APPEND_CUMULATIVE_PRODUCTION_V2_DAILY;
var FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_FAILURE = 'performance/FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_FAILURE';
exports.FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_FAILURE = FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_FAILURE;
var FETCHING_CUMULATIVE_PRODUCTION_V2_DAILY = 'performance/FETCHING_CUMULATIVE_PRODUCTION_V2_DAILY'; // use a fake start date that encapsulates all pto dates so we can use all of the helper functions

exports.FETCHING_CUMULATIVE_PRODUCTION_V2_DAILY = FETCHING_CUMULATIVE_PRODUCTION_V2_DAILY;
var startDate = '2000-01-01';

var getReadingsFromState = function getReadingsFromState(rpcCumulativeProductionDailyV2, prospectId, endDate) {
  var luxonStart = _luxon.DateTime.fromISO(startDate);

  var luxonEnd = _luxon.DateTime.fromISO(endDate);

  var readings = rpcCumulativeProductionDailyV2.get('readings');
  return readings.filter(function (reading) {
    return (0, _timeseriesHelpers.hasSameValues)(reading, prospectId, luxonStart, luxonEnd);
  });
};

var fetchCumulativeProductionDailyV2Success = function fetchCumulativeProductionDailyV2Success(performance) {
  return {
    type: FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_SUCCESS,
    payload: performance
  };
};

exports.fetchCumulativeProductionDailyV2Success = fetchCumulativeProductionDailyV2Success;

var appendCumulativeProductionDailyV2Page = function appendCumulativeProductionDailyV2Page(performance) {
  return {
    type: APPEND_CUMULATIVE_PRODUCTION_V2_DAILY,
    payload: performance
  };
};

exports.appendCumulativeProductionDailyV2Page = appendCumulativeProductionDailyV2Page;

var fetchCumulativeProductionDailyV2Failure = function fetchCumulativeProductionDailyV2Failure(err, prospectId, endDate) {
  return {
    type: FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_FAILURE,
    payload: {
      error: err,
      startDate: startDate,
      endDate: endDate,
      prospectId: prospectId
    }
  };
};

exports.fetchCumulativeProductionDailyV2Failure = fetchCumulativeProductionDailyV2Failure;

var fetchingCumulativeProductionDailyV2 = function fetchingCumulativeProductionDailyV2(prospectId, endDate) {
  return {
    type: FETCHING_CUMULATIVE_PRODUCTION_V2_DAILY,
    payload: {
      prospectId: prospectId,
      startDate: startDate,
      endDate: endDate
    }
  };
};

exports.fetchingCumulativeProductionDailyV2 = fetchingCumulativeProductionDailyV2;

var fetchAllCumulativeProductionDailyV2Pages = function fetchAllCumulativeProductionDailyV2Pages(prospectId, initialEndDate, nextEndDate, baseUrl, authToken) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var formattedEndDate, _yield$GetCumulativeP, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formattedEndDate = _luxon.DateTime.fromISO(nextEndDate).toISODate();
              _context.next = 3;
              return (0, _CumulativeProduction.GetCumulativeProductionDailyV2)(prospectId, formattedEndDate, baseUrl, authToken);

            case 3:
              _yield$GetCumulativeP = _context.sent;
              data = _yield$GetCumulativeP.data;
              dispatch(appendCumulativeProductionDailyV2Page({
                data: data.readings,
                prospectId: prospectId,
                startDate: startDate,
                endDate: initialEndDate
              }));

              if (data.nextEndDate) {
                dispatch(fetchAllCumulativeProductionDailyV2Pages(prospectId, initialEndDate, data.nextEndDate, baseUrl, authToken));
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var fetchCumulativeProductionDailyV2 = function fetchCumulativeProductionDailyV2(prospectId, endDate, baseUrl, authToken) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var formattedEndDate, _yield$GetCumulativeP2, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchingCumulativeProductionDailyV2(prospectId, endDate));
              _context2.prev = 1;
              formattedEndDate = _luxon.DateTime.fromISO(endDate).toISODate();
              _context2.next = 5;
              return (0, _CumulativeProduction.GetCumulativeProductionDailyV2)(prospectId, formattedEndDate, baseUrl, authToken);

            case 5:
              _yield$GetCumulativeP2 = _context2.sent;
              data = _yield$GetCumulativeP2.data;
              dispatch(fetchCumulativeProductionDailyV2Success({
                data: data.readings,
                prospectId: prospectId,
                startDate: startDate,
                endDate: endDate
              }));

              if (data.nextEndDate) {
                dispatch(fetchAllCumulativeProductionDailyV2Pages(prospectId, endDate, data.nextEndDate, baseUrl, authToken));
              }

              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);
              dispatch(fetchCumulativeProductionDailyV2Failure(_context2.t0.message, prospectId, endDate));

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 11]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.fetchCumulativeProductionDailyV2 = fetchCumulativeProductionDailyV2;

var fetchCumulativeProductionDailyV2IfNeeded = function fetchCumulativeProductionDailyV2IfNeeded(prospectId, endDate, baseUrl, authToken) {
  return function (dispatch, getState) {
    var _getState = getState(),
        rpcCumulativeProductionDailyV2 = _getState.rpcCumulativeProductionDailyV2;

    if (rpcCumulativeProductionDailyV2.get('loading')) {
      return null;
    }

    var existing = getReadingsFromState(rpcCumulativeProductionDailyV2, prospectId, endDate);

    if (existing.size > 0) {
      return null;
    }

    return dispatch(fetchCumulativeProductionDailyV2(prospectId, endDate, baseUrl, authToken));
  };
};

exports.fetchCumulativeProductionDailyV2IfNeeded = fetchCumulativeProductionDailyV2IfNeeded;

var cumulativeProductionDailyV2Selector = function cumulativeProductionDailyV2Selector(state) {
  return state.rpcCumulativeProductionDailyV2;
};

var getCumulativeProductionDailyV2 = function getCumulativeProductionDailyV2(prospectId, endDate) {
  return (0, _reselect.createSelector)([cumulativeProductionDailyV2Selector], function (cumulativeProductionDailyV2) {
    return (0, _timeseriesHelpers.getReading)(prospectId, startDate, endDate, cumulativeProductionDailyV2, 'readings');
  });
};

exports.getCumulativeProductionDailyV2 = getCumulativeProductionDailyV2;
var getCumulativeProductionDailyV2Loading = (0, _reselect.createSelector)([cumulativeProductionDailyV2Selector], function (performance) {
  return performance.get('loading');
});
exports.getCumulativeProductionDailyV2Loading = getCumulativeProductionDailyV2Loading;
var getCumulativeProductionDailyV2Error = (0, _reselect.createSelector)([cumulativeProductionDailyV2Selector], function (performance) {
  return performance.get('error');
});
exports.getCumulativeProductionDailyV2Error = getCumulativeProductionDailyV2Error;
var cumulativeProductionDailyV2InitialState = (0, _immutable.fromJS)({
  readings: [],
  error: null,
  loading: false
});
exports.cumulativeProductionDailyV2InitialState = cumulativeProductionDailyV2InitialState;

var getAppendUpdateInParams = function getAppendUpdateInParams(state, action) {
  var readings = state.get('readings');
  var index = (0, _timeseriesHelpers.getIndex)(readings, action.payload.prospectId, startDate, action.payload.endDate);
  return ['readings', index, 'data'];
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cumulativeProductionDailyV2InitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_SUCCESS:
      return state.set('loading', false).updateIn(['readings'], function (arr) {
        return arr.push(action.payload);
      });

    case APPEND_CUMULATIVE_PRODUCTION_V2_DAILY:
      return state.updateIn(getAppendUpdateInParams(state, action), function (arr) {
        return action.payload.data.concat(arr);
      });

    case FETCH_CUMULATIVE_PRODUCTION_V2_DAILY_FAILURE:
      return state.set('loading', false).set('error', action.error);

    case FETCHING_CUMULATIVE_PRODUCTION_V2_DAILY:
      return state.set('loading', true);

    default:
      return state;
  }
};

exports["default"] = _default;